// extracted by mini-css-extract-plugin
export default {"curvesWrapper":"styles_curvesWrapper__Y2esL","blockWrapper":"styles_blockWrapper__JoYkL"};